import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Images } from "../assets";
import TitleSection from "../components/TitleSection/TitleSection";
import Button from "../components/Button";
import ScrollingNews from "../components/ScrollingNews";
import ScrollingLogos from "../components/ScrollingLogos";
import ContactForm from "../components/ContactForm";
import { useTranslation } from "react-i18next";

// Inline HomeCard component
const HomeCardComponent = ({ img, title, text }) => {
  return (
    <div className="flex flex-col gap-5 cursor-pointer">
      <div className="rounded-lg bg-turquoise pr-14 pb-14 p-3 sm:rounded-xl">
        <img
          src={img}
          alt={title}
          className="rounded filter grayscale w-full h-auto lg:w-[27vw] lg:h-[27vh] lg:rounded-xl"
        />
      </div>
      <div className="text-start mt-3 space-y-2">
        <h3 className="text-xl font-bold">{title}</h3>
        <p className="text-[#BCBCBC]">{text}</p>
      </div>
    </div>
  );
};

const HoverCard = ({ img, title, text, url }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="group flex flex-col gap-5 h-fit transition-all duration-300"
      onClick={() => {
        if (window.innerWidth < 1024) setOpen(!open);
      }}
    >
      <NavLink
        to={url}
        className={`block overflow-hidden transition-all duration-300 ease-in-out ${
          open ? "max-h-40" : "max-h-0"
        } lg:group-hover:max-h-40`}
      >
        <Button
          text="En savoir plus"
          width="100%"
          px="px-8"
          py="py-7"
          orientation={"north-east"}
        />
      </NavLink>
      <HomeCardComponent img={img} title={title} text={text} />
    </div>
  );
};

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <TitleSection
        title={t("home.title")}
        subtitle={t("home.subtitle")}
        highlightWords={[t("home.highlightWords")]}
        bgImg={Images.HOME_BG_IMAGE}
        home={true}
      />

      {/* HomeCards Section */}
      <section className="mt-5 px-5 md:px-10 h-fit lg:h-[60vh]">
        <div className="grid grid-cols-1 gap-5 items-stretch lg:grid-cols-3">
          <HoverCard
            img={Images.HYDRAULIQUE_BG_IMAGE}
            alt="Hydraulique"
            title={t("home.hydraulique.title")}
            text={t("home.hydraulique.text")}
            url="/hydraulique"
          />
          <HoverCard
            img={Images.OXYCOUPAGE_BG_IMAGE}
            title={t("home.oxycoupage.title")}
            text={t("home.oxycoupage.text")}
            url="/oxycoupage"
          />
          <HoverCard
            img={Images.RD_BG_IMAGE}
            title={t("home.rd.title")}
            text={t("home.rd.text")}
            url="/r&d"
          />
        </div>
      </section>

      {/* Machines Overview Section */}
      <section className="flex flex-col md:flex-row justify-between items-center mt-24 px-5 md:px-10">
        <div className="flex flex-col gap-5 items-center md:items-start w-full md:w-1/2 text-center md:text-start">
          <h2 className="font-title text-4xl uppercase">
            {t("machines.title")}{" "}
            <span className="text-orange">{t("machines.highlight")}</span>
          </h2>
          <p className="italic">{t("machines.description")}</p>
          <NavLink to="/nos-machines">
            <Button text={t("machines.button")} orientation={"north-east"} />
          </NavLink>
        </div>
        <img
          src={Images.ORANGE_STREAKS}
          alt="Streaks"
          className="hidden md:block -mr-10"
        />
      </section>

      {/* Scrolling News Section */}
      <section className="flex flex-col mt-32 px-5 md:px-10">
        <h2 className="font-title uppercase text-4xl text-start">
          {t("news.title")}
        </h2>
        <ScrollingNews />
      </section>

      {/* Scrolling Logos Section */}
      <section className="flex flex-col mt-32 px-5 md:px-10">
        <h2 className="font-title uppercase text-4xl mb-5 text-start">
          {t("logos.title")}{" "}
          <span className="text-orange">{t("logos.highlight")}</span> !
        </h2>
        <ScrollingLogos />
      </section>

      {/* Contact Form Section */}
      <section className="mt-24 px-5 md:px-10">
        <ContactForm />
      </section>
    </>
  );
};

export default Home;
